import { render } from "./LogoGoIcon.vue?vue&type=template&id=7918b504"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/LogoGoIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7918b504"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7918b504', __exports__)) {
    api.reload('7918b504', __exports__)
  }
  
  module.hot.accept("./LogoGoIcon.vue?vue&type=template&id=7918b504", () => {
    api.rerender('7918b504', render)
  })

}


export default __exports__